// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* iOS profile card theme tokens – follow global light/dark mode on html/body */
.dark-mode {
  --bg-card: rgba(255, 255, 255, 0.04);
  --profile-hover-bg: rgba(255, 255, 255, 0.06);
  --profile-subtle-bg: rgba(255, 255, 255, 0.03);
  --profile-input-bg: rgba(0, 0, 0, 0.35);
  --profile-input-border: rgba(255, 255, 255, 0.15);
  --profile-segmented-bg: rgba(116, 116, 128, 0.18);
  --profile-drag-handle: rgba(255, 255, 255, 0.2);
  --profile-avatar-bg: linear-gradient(135deg, #1c1d22 0%, #101114 100%);
  --profile-badge-bg: rgba(255, 255, 255, 0.06);
  --profile-badge-border: rgba(255, 255, 255, 0.1);
  --profile-ring-bg: rgba(255, 255, 255, 0.08);
  --profile-gear-bg: rgba(28, 28, 30, 0.35);
  --profile-gear-edit-color: rgba(255, 255, 255, 0.4);
  --profile-secondary-text: rgba(255, 255, 255, 0.9);
}

.light-mode {
  --bg-card: rgba(0, 0, 0, 0.03);
  --profile-hover-bg: rgba(0, 0, 0, 0.04);
  --profile-subtle-bg: rgba(0, 0, 0, 0.03);
  --profile-input-bg: rgba(0, 0, 0, 0.04);
  --profile-input-border: rgba(0, 0, 0, 0.12);
  --profile-segmented-bg: rgba(120, 120, 128, 0.12);
  --profile-drag-handle: rgba(0, 0, 0, 0.15);
  --profile-avatar-bg: linear-gradient(135deg, #f0f1f3 0%, #e4e6ea 100%);
  --profile-badge-bg: rgba(0, 0, 0, 0.04);
  --profile-badge-border: rgba(0, 0, 0, 0.08);
  --profile-ring-bg: rgba(0, 0, 0, 0.08);
  --profile-gear-bg: rgba(0, 0, 0, 0.03);
  --profile-gear-edit-color: rgba(0, 0, 0, 0.35);
  --profile-secondary-text: var(--text-color);
}

.user-info {
  /* Use global brand tokens from BrandContext — do not redeclare --brand-*
     (circular var(--brand-primary, …) made the active tab pill invisible). */
  --brand-warning: #FF9F0A;
  --brand-success: #32D74B;
  --brand-danger: #FF453A;
  --brand-purple: #BF5AF2;
  --brand-yellow: #FFD60A;

  --profile-card-bg: var(--glass-bg);
  --profile-card-border: 1px solid var(--glass-border);
  --profile-card-shadow: 0 12px 30px var(--shadow-color);
  --border-card: 1px solid var(--border-color);

  background: var(--bg-color) !important;
  min-height: 100vh;
  padding-bottom: 80px;
  color: var(--text-color);
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* User Info Layout */
.user-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.65rem 1.25rem 1.5rem;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  box-sizing: border-box;
}

/* Glass Card Containers */
.ios-profile-card {
  width: 100%;
  background: var(--profile-card-bg);
  border-radius: 28px;
  border: var(--profile-card-border);
  box-shadow: var(--profile-card-shadow);
  backdrop-filter: blur(20px);
  padding: 16px 20px 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  overflow: hidden;
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

/* Profile Header Section */
.ios-profile-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding-top: 0;
}

.ios-avatar-wrapper {
  position: relative;
  width: 90px;
  height: 90px;
}

.ios-avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--brand-primary, #0877BC);
  box-shadow: 0 0 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3);
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.ios-avatar:hover {
  transform: scale(1.05);
}

.ios-avatar-placeholder {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: var(--profile-avatar-bg);
  border: 3px solid var(--brand-primary, #0877BC);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 38px;
  font-weight: bold;
  color: var(--brand-primary, #0877BC);
  text-transform: uppercase;
}

.ios-profile-header h2 {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0;
  letter-spacing: -0.5px;
}

.ios-profile-header .ios-profile-relationship {
  margin: 2px 0 0;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.ios-profile-header .ios-email {
  font-size: 13px;
  font-weight: 400;
  color: var(--text-secondary);
  margin: -6px 0 0 0;
}

.profile-role {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2px 0 6px;
  width: 100%;
}

.profile-role__label,
.profile-role__select {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.28rem 0.8rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: center;
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);
}

.profile-role__switch {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  width: auto;
}

.profile-role__legend {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-secondary, #64748b);
  text-align: center;
}

.profile-role__select {
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: center;
  text-align-last: center;
  padding: 0.28rem 1.7rem 0.28rem 1rem;
  min-width: 7.5rem;
  background-image: linear-gradient(45deg, transparent 50%, currentColor 50%),
    linear-gradient(135deg, currentColor 50%, transparent 50%);
  background-position: calc(100% - 12px) 50%, calc(100% - 7px) 50%;
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
}

.profile-role__select:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.ios-club-under-name {
  margin: -2px 0 0;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-secondary, #64748b);
  letter-spacing: -0.01em;
}

.profile-staff-health-note {
  margin: 4px 0 0;
  padding: 0 4px;
  font-size: 0.68rem;
  line-height: 1.45;
  color: var(--text-secondary, #64748b);
  text-align: center;
  opacity: 0.9;
}

.ios-profile-header .ios-profile-alias {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  margin: 2px 0 0 0;
}

/* Club Badge Pill */
.ios-club-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: var(--profile-badge-bg);
  border: 1px solid var(--profile-badge-border);
  padding: 6px 14px;
  border-radius: 14px;
  margin-top: 4px;
}

.ios-club-badge--parent {
  gap: 12px;
  padding: 10px 16px;
  border-radius: 16px;
  max-width: 100%;
}

.ios-club-logo {
  width: 18px;
  height: 18px;
  object-fit: contain;
  border-radius: 4px;
}

.ios-club-badge--parent .ios-club-logo {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  flex-shrink: 0;
}

.ios-club-logo-placeholder {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ios-club-badge .ios-club-logo-placeholder.club-logo-mark {
  width: 18px;
  height: 18px;
  border-radius: 5px;
}

.ios-club-badge .ios-club-logo-placeholder.club-logo-mark .club-logo-mark__icon {
  font-size: 12px !important;
  width: 12px !important;
  height: 12px !important;
}

.ios-club-badge--parent .ios-club-logo-placeholder {
  font-size: 28px;
  width: 40px;
  height: 40px;
}

.ios-club-badge--parent .ios-club-logo-placeholder.club-logo-mark {
  width: 40px;
  height: 40px;
  border-radius: 10px;
}

.ios-club-badge--parent .ios-club-logo-placeholder.club-logo-mark .club-logo-mark__icon {
  font-size: 26px !important;
  width: 26px !important;
  height: 26px !important;
}

.ios-club-name {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-color);
}

.ios-club-badge--parent .ios-club-name {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.25;
  text-align: left;
}

/* Gamified Level & XP Container */
.ios-gaming-level-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 280px;
  margin: 14px auto 4px auto;
  gap: 8px;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04);
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
  padding: 12px;
  border-radius: 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.ios-gaming-level-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ios-gaming-level-badge {
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877BC),
    var(--brand-primary-light, var(--brand-secondary, #30D5C8))
  );
  color: #ffffff;
  font-size: 11px;
  font-weight: 800;
  padding: 3px 8px;
  border-radius: 8px;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.ios-gaming-xp-text {
  font-size: 11px;
  font-weight: 700;
  color: var(--text-color);
  opacity: 0.8;
}

.ios-gaming-xp-track {
  width: 100%;
  height: 6px;
  background-color: var(--profile-segmented-bg, rgba(120, 120, 128, 0.15));
  border-radius: 3px;
  overflow: hidden;
}

.ios-gaming-xp-bar {
  height: 100%;
  background: linear-gradient(
    90deg,
    var(--brand-primary, #0877BC),
    var(--brand-primary-light, var(--brand-secondary, #30D5C8))
  );
  border-radius: 3px;
  box-shadow: 0 0 8px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4);
  transition: width 0.6s cubic-bezier(0.25, 1, 0.5, 1);
}

.ios-gaming-streak-badge {
  font-size: 10px;
  font-weight: 800;
  color: #FF9F0A;
  align-self: center;
  letter-spacing: 0.5px;
  animation: streakGlow 2s infinite alternate;
}

@keyframes streakGlow {
  from {
    text-shadow: 0 0 4px rgba(255, 159, 10, 0.1);
  }
  to {
    text-shadow: 0 0 8px rgba(255, 159, 10, 0.4);
  }
}

/* Custom Sliding Segmented Tab Controller — brand pill */
.ios-segmented-control {
  background-color: var(--profile-segmented-bg);
  border-radius: 16px;
  padding: 4px;
  display: flex;
  position: relative;
  height: 44px;
  box-sizing: border-box;
  align-items: center;
  margin-top: 8px;
}

.ios-segmented-control-btn {
  flex: 1 1;
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  z-index: 2;
  transition: color 0.2s ease;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

.ios-segmented-control-btn:hover:not(.active) {
  color: var(--brand-primary, #0877BC);
}

.ios-segmented-control-btn.active {
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
}

.ios-segmented-indicator {
  position: absolute;
  top: 4px;
  bottom: 4px;
  background: linear-gradient(
    135deg,
    var(--brand-primary-light, var(--brand-primary, #0877BC)) 0%,
    var(--brand-primary, #0877BC) 55%,
    var(--brand-primary-dark, var(--brand-primary, #065a8f)) 100%
  );
  border-radius: 12px;
  z-index: 1;
  transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1), width 0.3s ease;
  box-shadow:
    0 2px 10px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4),
    0 1px 3px rgba(0, 0, 0, 0.12);
}

/* Tab Containers */
.ios-tab-content-wrapper {
  margin-top: 4px;
}

.ios-tab-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
  animation: tabFadeIn 0.35s ease;
}

@keyframes tabFadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Tab 1: Profile Elements */
.ios-attribute-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.ios-attribute-card {
  background: var(--bg-card);
  border: var(--border-card);
  border-radius: 16px;
  height: 56px;
  display: flex;
  align-items: center;
  padding: 12px;
  box-sizing: border-box;
  gap: 12px;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.ios-attribute-card:hover {
  background-color: var(--profile-hover-bg);
  transform: translateY(-1px);
}

.ios-attribute-card.full-width {
  grid-column: 1 / -1;
}

.ios-attribute-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 20px;
}

.ios-attribute-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  flex: 1 1;
}

.ios-attribute-title {
  font-size: 10px;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.ios-attribute-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-color);
  margin-top: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ios-attribute-card--ranking {
  height: auto;
  min-height: 56px;
  align-items: flex-start;
  padding-top: 12px;
  padding-bottom: 12px;
}

.ios-attribute-card--ranking .ios-attribute-icon-wrapper {
  margin-top: 2px;
}

.ios-ranking-place {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  letter-spacing: 0.02em;
}

.ios-ranking-week {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.ios-ranking-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  font-variant-numeric: tabular-nums;
}

.ios-ranking-chip--up {
  color: #0f7a32;
  background: rgba(50, 215, 75, 0.18);
}

.ios-ranking-chip--down {
  color: #c42822;
  background: rgba(255, 69, 58, 0.16);
}

.dark-mode .ios-ranking-chip--up {
  color: #86f09a;
}

.dark-mode .ios-ranking-chip--down {
  color: #ff8a82;
}

/* Objectives Card */
.ios-objectives-card {
  background: var(--bg-card);
  border: var(--border-card);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.club-health-card {
  margin-top: 16px;
  text-align: left;
  color: var(--text-color);
}

.club-health-card .ios-objectives-header h3 {
  color: var(--text-secondary);
}

.club-health-card .scforh-intro,
.club-health-card .who-capsule,
.club-health-card .scforh-dim-status {
  margin: 0.65rem 0 0;
}

.club-health-card .who-capsule {
  max-height: 42vh;
  overflow-y: auto;
}

.who-capsule-profile {
  width: min(100%, 360px);
  margin: 12px auto 0;
}

.club-health-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.club-health-chip {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(8, 119, 188, 0.1);
  color: var(--brand-primary, #0877BC);
  font-size: 12px;
  font-weight: 600;
}

.club-health-empty {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary);
}

.club-health-letters {
  display: flex;
  gap: 8px;
}

.club-health-letter {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 13px;
  background: #eee;
  color: #888;
}

.club-health-letter--partial {
  background: #fff4d6;
  color: #b58100;
}

.club-health-letter--complete {
  background: #d9f5e3;
  color: #1b7a43;
}

.club-health-cta {
  border: none;
  border-radius: 12px;
  padding: 12px 14px;
  font-weight: 700;
  cursor: pointer;
  background: var(--brand-primary, #0877BC);
  color: #fff;
}

.ios-objectives-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ios-objectives-header h3 {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 0.5px;
}

.ios-objective-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ios-objective-subtitle {
  font-size: 13px;
  font-weight: 700;
}

.ios-objective-subtitle.primary {
  color: var(--brand-primary, #0877BC);
}

.ios-objective-subtitle.secondary {
  color: var(--brand-secondary);
}

.ios-primary-box {
  background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);
  border-radius: 10px;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-color);
  line-height: 1.4;
}

.ios-secondary-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background-color: var(--profile-subtle-bg);
  padding: 10px 12px;
  border-radius: 8px;
  margin-bottom: 6px;
}

.ios-secondary-item:last-child {
  margin-bottom: 0;
}

.ios-bullet {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--brand-secondary);
  margin-top: 6px;
  flex-shrink: 0;
}

.ios-secondary-text {
  font-size: 13px;
  font-weight: 500;
  color: var(--profile-secondary-text);
  line-height: 1.3;
}

/* Tab 2: Stats Elements */
.ios-tab-content--stats {
  gap: 12px;
}

.ios-stats-title {
  font-size: 11px;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: -4px;
  padding-left: 4px;
}

.ios-stat-heading {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ios-stat-icon {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ios-stat-icon--train {
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, transparent);
}

.ios-stat-icon--cardio {
  color: var(--brand-danger, #ff453a);
  background: color-mix(in srgb, var(--brand-danger, #ff453a) 14%, transparent);
}

.ios-stat-icon-well {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ios-stat-icon-well--streak {
  color: #fff;
  background: linear-gradient(
    145deg,
    var(--brand-warning, #ff9f0a) 0%,
    color-mix(in srgb, var(--brand-danger, #ff453a) 55%, var(--brand-warning, #ff9f0a)) 100%
  );
  box-shadow: 0 8px 18px color-mix(in srgb, var(--brand-warning, #ff9f0a) 35%, transparent);
}

.ios-fltt-form {
  margin: 0 0 14px;
  padding: 16px;
  border-radius: 18px;
  background: var(--bg-card);
  border: 1px solid color-mix(in srgb, #12362c 28%, var(--border-color, #d5ddd8));
}

.ios-fltt-form p {
  margin: 6px 0 0;
}

.ios-fltt-form button {
  margin-top: 12px;
  border: 0;
  border-radius: 999px;
  background: #12362c;
  color: #f3f6f4;
  padding: 8px 14px;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.ios-activity-card {
  background: var(--bg-card);
  border: var(--border-card);
  border-radius: 18px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 20px;
  min-height: 112px;
  box-sizing: border-box;
  overflow: visible;
}

.ios-activity-card--weekly {
  gap: 16px;
  padding: 18px 16px;
  background:
    radial-gradient(
      90% 120% at 0% 50%,
      color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent),
      transparent 60%
    ),
    var(--bg-card);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--border-color, transparent));
}

.ios-activity-card--streak {
  background:
    radial-gradient(
      90% 120% at 0% 50%,
      color-mix(in srgb, var(--brand-warning, #ff9f0a) 12%, transparent),
      transparent 60%
    ),
    var(--bg-card);
  border: 1px solid color-mix(in srgb, var(--brand-warning, #ff9f0a) 18%, var(--border-color, transparent));
}

/* Activity Ring SVG — viewBox keeps the stroke fully visible when scaled */
.ios-ring-container {
  position: relative;
  width: 84px;
  height: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  overflow: visible;
}

.ios-ring-svg {
  transform: rotate(-90deg);
  width: 84px;
  height: 84px;
  overflow: visible;
  display: block;
}

.ios-ring-bg {
  fill: none;
  stroke: var(--profile-ring-bg);
  stroke-width: 7;
}

.ios-ring-fill {
  fill: none;
  stroke: var(--brand-primary, #0877BC);
  stroke-width: 7;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.ios-ring-text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: var(--text-color);
  pointer-events: none;
}

.ios-activity-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1 1;
}

.ios-activity-info h4 {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.ios-activity-value {
  font-size: 22px;
  font-weight: 800;
  color: var(--text-color);
  margin: 0;
}

.ios-activity-sub {
  font-size: 12px;
  font-weight: 600;
  color: var(--brand-primary, #0877BC);
  margin: 0;
}

/* Streak Card */
.ios-streak-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.ios-streak-info h4 {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.ios-streak-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0;
}

.ios-streak-sub {
  font-size: 11px;
  font-weight: 400;
  color: var(--text-secondary);
  line-height: 1.3;
  margin: 0;
}

/* Cardio Card & Mini Metrics */
.ios-cardio-card {
  background:
    radial-gradient(
      80% 100% at 100% 0%,
      color-mix(in srgb, var(--brand-secondary, #30d5c8) 10%, transparent),
      transparent 55%
    ),
    var(--bg-card);
  border: 1px solid color-mix(in srgb, var(--brand-secondary, #30d5c8) 16%, var(--border-color, transparent));
  border-radius: 18px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ios-cardio-header {
  font-size: 11px;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.ios-mini-metrics-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.ios-mini-metric-item {
  background-color: var(--profile-subtle-bg);
  border: 1px solid var(--border-color);
  border-radius: 14px;
  padding: 12px 6px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
}

.ios-mini-metric-item--hr {
  border-color: color-mix(in srgb, var(--brand-danger, #ff453a) 22%, transparent);
  background: color-mix(in srgb, var(--brand-danger, #ff453a) 7%, var(--bg-card, transparent));
}

.ios-mini-metric-item--hr .ios-metric-glyph {
  color: var(--brand-danger, #ff453a);
}

.ios-mini-metric-item--max {
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 7%, var(--bg-card, transparent));
}

.ios-mini-metric-item--max .ios-metric-glyph {
  color: var(--brand-primary, #0877bc);
}

.ios-mini-metric-item--kcal {
  border-color: color-mix(in srgb, var(--brand-warning, #ff9f0a) 24%, transparent);
  background: color-mix(in srgb, var(--brand-warning, #ff9f0a) 8%, var(--bg-card, transparent));
}

.ios-mini-metric-item--kcal .ios-metric-glyph {
  color: var(--brand-warning, #ff9f0a);
}

.ios-metric-glyph {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 9px;
  background: color-mix(in srgb, currentColor 12%, transparent);
}

.ios-metric-icon {
  font-size: 18px;
  margin-bottom: 4px;
}

.ios-metric-value {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-color);
  line-height: 1.2;
}

.ios-metric-label {
  font-size: 9px;
  font-weight: 600;
  color: var(--text-secondary);
  margin-top: 1px;
}

/* Tab 3: My Gear Elements */
.ios-gear-slot {
  background: var(--profile-gear-bg);
  border-radius: 16px;
  border-width: 1.5px;
  border-style: solid;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: auto;
  min-height: 58px;
  box-sizing: border-box;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.ios-gear-slot.blade { border-color: rgba(255, 159, 10, 0.25); }
.ios-gear-slot.forehand { border-color: rgba(255, 69, 58, 0.25); }
.ios-gear-slot.backhand { border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25); }

.ios-gear-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1 1;
}

.ios-gear-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  width: 24px;
  height: 24px;
}

.ios-gear-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.ios-gear-slot-title {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.ios-gear-slot.blade .ios-gear-slot-title { color: var(--brand-warning); }
.ios-gear-slot.forehand .ios-gear-slot-title { color: var(--brand-danger); }
.ios-gear-slot.backhand .ios-gear-slot-title { color: var(--brand-primary, #0877BC); }

.ios-gear-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-color);
  margin-top: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ios-gear-edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--profile-gear-edit-color);
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: color 0.2s ease, background-color 0.2s ease, transform 0.15s ease;
}

.ios-gear-edit-btn:hover {
  color: var(--text-color);
  background-color: var(--profile-hover-bg);
  transform: scale(1.08);
}

/* Gear Inline Form Edit State */
.ios-gear-edit-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  animation: formExpand 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes formExpand {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ios-gear-edit-title {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.ios-gear-edit-inputs {
  display: flex;
  gap: 8px;
  width: 100%;
}

.ios-gear-input {
  flex: 1 1;
  background-color: var(--profile-input-bg);
  border: 1px solid var(--profile-input-border);
  border-radius: 8px;
  color: var(--text-color);
  padding: 8px 12px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s ease;
}

.ios-gear-input:focus {
  border-color: var(--brand-primary, #0877BC);
}

.ios-gear-btn-save {
  background-color: var(--brand-primary, #0877BC);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.ios-gear-btn-save:hover {
  opacity: 0.9;
}

.ios-gear-btn-cancel {
  background-color: var(--profile-subtle-bg);
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.ios-gear-btn-cancel:hover {
  background-color: var(--profile-hover-bg);
  color: var(--text-color);
}

/* Weight Metric Card */
.ios-weight-card {
  background: var(--bg-card);
  border: var(--border-card);
  border-radius: 14px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  box-sizing: border-box;
}

.ios-weight-left {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 500;
}

.ios-weight-icon {
  font-size: 18px;
  opacity: 0.7;
}

.ios-weight-value {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
}

/* Local Feedback Banner (for inline save feedback) */
.ios-local-toast {
  background-color: rgba(50, 215, 75, 0.15);
  border: 1px solid rgba(50, 215, 75, 0.3);
  color: var(--brand-success);
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  animation: slideDownToast 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes slideDownToast {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Overrides for Userinfo */
@media (max-width: 540px) {
  .ios-profile-card {
    border-radius: 20px;
    padding: 16px;
    gap: 16px;
  }
  .ios-avatar-wrapper, .ios-avatar, .ios-avatar-placeholder {
    width: 80px;
    height: 80px;
  }
  .ios-avatar-placeholder {
    font-size: 32px;
  }
  .ios-profile-header h2 {
    font-size: 18px;
  }
  .ios-profile-header .ios-email {
    font-size: 12px;
  }
  .ios-segmented-control {
    height: 40px;
  }
  .ios-segmented-control-btn {
    font-size: 13px;
  }
  .ios-segmented-indicator {
    border-radius: 10px;
  }
  .ios-attribute-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .ios-mini-metrics-row {
    gap: 6px;
  }
  .ios-mini-metric-item {
    padding: 8px 4px;
  }
  .ios-metric-value {
    font-size: 12px;
  }
  .ios-activity-card {
    gap: 12px;
  }
  .ios-activity-card--weekly {
    gap: 14px;
    padding: 16px 14px;
    min-height: 104px;
    align-items: center;
  }
  .ios-ring-container {
    width: 76px;
    height: 76px;
  }
  .ios-ring-svg {
    width: 76px;
    height: 76px;
  }
  .ios-ring-text {
    font-size: 13px;
  }
  .ios-activity-value {
    font-size: 18px;
    line-height: 1.2;
    word-break: break-word;
  }
}

/* Dedicated class for compact 2-column grid inside dialogs */
.ios-attribute-grid.dialog-attribute-grid {
  grid-template-columns: repeat(2, 1fr) !important;
  gap: 10px !important;
}

/* Narrow mobile overrides to prevent tab label overlaps */
@media (max-width: 400px) {
  .ios-segmented-control-btn {
    font-size: 11px !important;
    letter-spacing: -0.2px !important;
  }
}

@media (max-width: 340px) {
  .ios-segmented-control-btn {
    font-size: 10px !important;
    letter-spacing: -0.4px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Userinfo.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,8CAA8C;EAC9C,uCAAuC;EACvC,iDAAiD;EACjD,iDAAiD;EACjD,+CAA+C;EAC/C,sEAAsE;EACtE,6CAA6C;EAC7C,gDAAgD;EAChD,4CAA4C;EAC5C,yCAAyC;EACzC,mDAAmD;EACnD,kDAAkD;AACpD;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,wCAAwC;EACxC,uCAAuC;EACvC,2CAA2C;EAC3C,iDAAiD;EACjD,0CAA0C;EAC1C,sEAAsE;EACtE,uCAAuC;EACvC,2CAA2C;EAC3C,sCAAsC;EACtC,sCAAsC;EACtC,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE;6EAC2E;EAC3E,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,kCAAkC;EAClC,oDAAoD;EACpD,sDAAsD;EACtD,4CAA4C;;EAE5C,sCAAsC;EACtC,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,iIAAiI;EACjI,aAAa;EACb,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,kCAAkC;EAClC,mBAAmB;EACnB,kCAAkC;EAClC,sCAAsC;EACtC,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oFAAoF;AACtF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,+CAA+C;EAC/C,qEAAqE;EACrE,4DAA4D;AAC9D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,+CAA+C;EAC/C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,8EAA8E;EAC9E,oFAAoF;AACtF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;EACjB;8DAC4D;EAC5D,gEAAgE;EAChE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yCAAyC;EACzC,6CAA6C;EAC7C,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,QAAQ;EACR,6DAA6D;EAC7D,mEAAmE;EACnE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;;;;GAIC;EACD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,uEAAuE;EACvE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wEAAwE;EACxE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ;;;;GAIC;EACD,kBAAkB;EAClB,oEAAoE;EACpE,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA,yDAAyD;AACzD;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX;;;;;GAKC;EACD,mBAAmB;EACnB,UAAU;EACV,yEAAyE;EACzE;;iCAE+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mEAAmE;EACnE,mEAAmE;EACnE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8EAA8E;AAChF;;AAEA;EACE,mCAAmC;EACnC,6EAA6E;AAC/E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX;;;;GAIC;EACD,yFAAyF;AAC3F;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,+EAA+E;AACjF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB;;;;;;kBAMgB;EAChB,yGAAyG;AAC3G;;AAEA;EACE;;;;;;kBAMgB;EAChB,yGAAyG;AAC3G;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,eAAe;EACf,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE;;;;;;kBAMgB;EAChB,2GAA2G;EAC3G,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;EAC/E,4FAA4F;AAC9F;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gFAAgF;EAChF,6FAA6F;AAC/F;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gFAAgF;EAChF,6FAA6F;AAC/F;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,8DAA8D;AAChE;;AAEA,uBAAuB,sCAAsC,EAAE;AAC/D,0BAA0B,qCAAqC,EAAE;AACjE,0BAA0B,+DAA+D,EAAE;;AAE3F;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,4CAA4C,2BAA2B,EAAE;AACzE,+CAA+C,0BAA0B,EAAE;AAC3E,+CAA+C,oCAAoC,EAAE;;AAErF;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kEAAkE;AACpE;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;EACP,yCAAyC;EACzC,6CAA6C;EAC7C,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;EAC/C,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,qDAAqD;AACrD;EACE,yCAAyC;EACzC,wCAAwC;EACxC,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qEAAqE;AACvE;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA,6DAA6D;AAC7D;EACE,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA,0DAA0D;AAC1D;EACE;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;AACF","sourcesContent":["/* iOS profile card theme tokens – follow global light/dark mode on html/body */\n.dark-mode {\n  --bg-card: rgba(255, 255, 255, 0.04);\n  --profile-hover-bg: rgba(255, 255, 255, 0.06);\n  --profile-subtle-bg: rgba(255, 255, 255, 0.03);\n  --profile-input-bg: rgba(0, 0, 0, 0.35);\n  --profile-input-border: rgba(255, 255, 255, 0.15);\n  --profile-segmented-bg: rgba(116, 116, 128, 0.18);\n  --profile-drag-handle: rgba(255, 255, 255, 0.2);\n  --profile-avatar-bg: linear-gradient(135deg, #1c1d22 0%, #101114 100%);\n  --profile-badge-bg: rgba(255, 255, 255, 0.06);\n  --profile-badge-border: rgba(255, 255, 255, 0.1);\n  --profile-ring-bg: rgba(255, 255, 255, 0.08);\n  --profile-gear-bg: rgba(28, 28, 30, 0.35);\n  --profile-gear-edit-color: rgba(255, 255, 255, 0.4);\n  --profile-secondary-text: rgba(255, 255, 255, 0.9);\n}\n\n.light-mode {\n  --bg-card: rgba(0, 0, 0, 0.03);\n  --profile-hover-bg: rgba(0, 0, 0, 0.04);\n  --profile-subtle-bg: rgba(0, 0, 0, 0.03);\n  --profile-input-bg: rgba(0, 0, 0, 0.04);\n  --profile-input-border: rgba(0, 0, 0, 0.12);\n  --profile-segmented-bg: rgba(120, 120, 128, 0.12);\n  --profile-drag-handle: rgba(0, 0, 0, 0.15);\n  --profile-avatar-bg: linear-gradient(135deg, #f0f1f3 0%, #e4e6ea 100%);\n  --profile-badge-bg: rgba(0, 0, 0, 0.04);\n  --profile-badge-border: rgba(0, 0, 0, 0.08);\n  --profile-ring-bg: rgba(0, 0, 0, 0.08);\n  --profile-gear-bg: rgba(0, 0, 0, 0.03);\n  --profile-gear-edit-color: rgba(0, 0, 0, 0.35);\n  --profile-secondary-text: var(--text-color);\n}\n\n.user-info {\n  /* Use global brand tokens from BrandContext — do not redeclare --brand-*\n     (circular var(--brand-primary, …) made the active tab pill invisible). */\n  --brand-warning: #FF9F0A;\n  --brand-success: #32D74B;\n  --brand-danger: #FF453A;\n  --brand-purple: #BF5AF2;\n  --brand-yellow: #FFD60A;\n\n  --profile-card-bg: var(--glass-bg);\n  --profile-card-border: 1px solid var(--glass-border);\n  --profile-card-shadow: 0 12px 30px var(--shadow-color);\n  --border-card: 1px solid var(--border-color);\n\n  background: var(--bg-color) !important;\n  min-height: 100vh;\n  padding-bottom: 80px;\n  color: var(--text-color);\n  font-family: -apple-system, BlinkMacSystemFont, \"SF Pro Text\", \"SF Pro Display\", \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  display: flex;\n  flex-direction: column;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* User Info Layout */\n.user-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0.65rem 1.25rem 1.5rem;\n  width: 100%;\n  max-width: 720px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n/* Glass Card Containers */\n.ios-profile-card {\n  width: 100%;\n  background: var(--profile-card-bg);\n  border-radius: 28px;\n  border: var(--profile-card-border);\n  box-shadow: var(--profile-card-shadow);\n  backdrop-filter: blur(20px);\n  padding: 16px 20px 24px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  position: relative;\n  overflow: hidden;\n  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n/* Profile Header Section */\n.ios-profile-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n  padding-top: 0;\n}\n\n.ios-avatar-wrapper {\n  position: relative;\n  width: 90px;\n  height: 90px;\n}\n\n.ios-avatar {\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid var(--brand-primary, #0877BC);\n  box-shadow: 0 0 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3);\n  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.ios-avatar:hover {\n  transform: scale(1.05);\n}\n\n.ios-avatar-placeholder {\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n  background: var(--profile-avatar-bg);\n  border: 3px solid var(--brand-primary, #0877BC);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 38px;\n  font-weight: bold;\n  color: var(--brand-primary, #0877BC);\n  text-transform: uppercase;\n}\n\n.ios-profile-header h2 {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-color);\n  margin: 0;\n  letter-spacing: -0.5px;\n}\n\n.ios-profile-header .ios-profile-relationship {\n  margin: 2px 0 0;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.ios-profile-header .ios-email {\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--text-secondary);\n  margin: -6px 0 0 0;\n}\n\n.profile-role {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 2px 0 6px;\n  width: 100%;\n}\n\n.profile-role__label,\n.profile-role__select {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.28rem 0.8rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  text-align: center;\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent);\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);\n}\n\n.profile-role__switch {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.2rem;\n  width: auto;\n}\n\n.profile-role__legend {\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #64748b);\n  text-align: center;\n}\n\n.profile-role__select {\n  appearance: none;\n  -webkit-appearance: none;\n  cursor: pointer;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  text-align: center;\n  text-align-last: center;\n  padding: 0.28rem 1.7rem 0.28rem 1rem;\n  min-width: 7.5rem;\n  background-image: linear-gradient(45deg, transparent 50%, currentColor 50%),\n    linear-gradient(135deg, currentColor 50%, transparent 50%);\n  background-position: calc(100% - 12px) 50%, calc(100% - 7px) 50%;\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n}\n\n.profile-role__select:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.ios-club-under-name {\n  margin: -2px 0 0;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-secondary, #64748b);\n  letter-spacing: -0.01em;\n}\n\n.profile-staff-health-note {\n  margin: 4px 0 0;\n  padding: 0 4px;\n  font-size: 0.68rem;\n  line-height: 1.45;\n  color: var(--text-secondary, #64748b);\n  text-align: center;\n  opacity: 0.9;\n}\n\n.ios-profile-header .ios-profile-alias {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  margin: 2px 0 0 0;\n}\n\n/* Club Badge Pill */\n.ios-club-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background-color: var(--profile-badge-bg);\n  border: 1px solid var(--profile-badge-border);\n  padding: 6px 14px;\n  border-radius: 14px;\n  margin-top: 4px;\n}\n\n.ios-club-badge--parent {\n  gap: 12px;\n  padding: 10px 16px;\n  border-radius: 16px;\n  max-width: 100%;\n}\n\n.ios-club-logo {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n  border-radius: 4px;\n}\n\n.ios-club-badge--parent .ios-club-logo {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  flex-shrink: 0;\n}\n\n.ios-club-logo-placeholder {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ios-club-badge .ios-club-logo-placeholder.club-logo-mark {\n  width: 18px;\n  height: 18px;\n  border-radius: 5px;\n}\n\n.ios-club-badge .ios-club-logo-placeholder.club-logo-mark .club-logo-mark__icon {\n  font-size: 12px !important;\n  width: 12px !important;\n  height: 12px !important;\n}\n\n.ios-club-badge--parent .ios-club-logo-placeholder {\n  font-size: 28px;\n  width: 40px;\n  height: 40px;\n}\n\n.ios-club-badge--parent .ios-club-logo-placeholder.club-logo-mark {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n}\n\n.ios-club-badge--parent .ios-club-logo-placeholder.club-logo-mark .club-logo-mark__icon {\n  font-size: 26px !important;\n  width: 26px !important;\n  height: 26px !important;\n}\n\n.ios-club-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-color);\n}\n\n.ios-club-badge--parent .ios-club-name {\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.25;\n  text-align: left;\n}\n\n/* Gamified Level & XP Container */\n.ios-gaming-level-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 280px;\n  margin: 14px auto 4px auto;\n  gap: 8px;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04);\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n  padding: 12px;\n  border-radius: 18px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.ios-gaming-level-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.ios-gaming-level-badge {\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877BC),\n    var(--brand-primary-light, var(--brand-secondary, #30D5C8))\n  );\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 800;\n  padding: 3px 8px;\n  border-radius: 8px;\n  letter-spacing: 0.5px;\n  box-shadow: 0 2px 8px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.ios-gaming-xp-text {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-color);\n  opacity: 0.8;\n}\n\n.ios-gaming-xp-track {\n  width: 100%;\n  height: 6px;\n  background-color: var(--profile-segmented-bg, rgba(120, 120, 128, 0.15));\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.ios-gaming-xp-bar {\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    var(--brand-primary, #0877BC),\n    var(--brand-primary-light, var(--brand-secondary, #30D5C8))\n  );\n  border-radius: 3px;\n  box-shadow: 0 0 8px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4);\n  transition: width 0.6s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.ios-gaming-streak-badge {\n  font-size: 10px;\n  font-weight: 800;\n  color: #FF9F0A;\n  align-self: center;\n  letter-spacing: 0.5px;\n  animation: streakGlow 2s infinite alternate;\n}\n\n@keyframes streakGlow {\n  from {\n    text-shadow: 0 0 4px rgba(255, 159, 10, 0.1);\n  }\n  to {\n    text-shadow: 0 0 8px rgba(255, 159, 10, 0.4);\n  }\n}\n\n/* Custom Sliding Segmented Tab Controller — brand pill */\n.ios-segmented-control {\n  background-color: var(--profile-segmented-bg);\n  border-radius: 16px;\n  padding: 4px;\n  display: flex;\n  position: relative;\n  height: 44px;\n  box-sizing: border-box;\n  align-items: center;\n  margin-top: 8px;\n}\n\n.ios-segmented-control-btn {\n  flex: 1;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  z-index: 2;\n  transition: color 0.2s ease;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n}\n\n.ios-segmented-control-btn:hover:not(.active) {\n  color: var(--brand-primary, #0877BC);\n}\n\n.ios-segmented-control-btn.active {\n  color: #ffffff;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);\n}\n\n.ios-segmented-indicator {\n  position: absolute;\n  top: 4px;\n  bottom: 4px;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary-light, var(--brand-primary, #0877BC)) 0%,\n    var(--brand-primary, #0877BC) 55%,\n    var(--brand-primary-dark, var(--brand-primary, #065a8f)) 100%\n  );\n  border-radius: 12px;\n  z-index: 1;\n  transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1), width 0.3s ease;\n  box-shadow:\n    0 2px 10px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4),\n    0 1px 3px rgba(0, 0, 0, 0.12);\n}\n\n/* Tab Containers */\n.ios-tab-content-wrapper {\n  margin-top: 4px;\n}\n\n.ios-tab-content {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  animation: tabFadeIn 0.35s ease;\n}\n\n@keyframes tabFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Tab 1: Profile Elements */\n.ios-attribute-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.ios-attribute-card {\n  background: var(--bg-card);\n  border: var(--border-card);\n  border-radius: 16px;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  box-sizing: border-box;\n  gap: 12px;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n.ios-attribute-card:hover {\n  background-color: var(--profile-hover-bg);\n  transform: translateY(-1px);\n}\n\n.ios-attribute-card.full-width {\n  grid-column: 1 / -1;\n}\n\n.ios-attribute-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  font-size: 20px;\n}\n\n.ios-attribute-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n  flex: 1;\n}\n\n.ios-attribute-title {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.ios-attribute-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-color);\n  margin-top: 1px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ios-attribute-card--ranking {\n  height: auto;\n  min-height: 56px;\n  align-items: flex-start;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.ios-attribute-card--ranking .ios-attribute-icon-wrapper {\n  margin-top: 2px;\n}\n\n.ios-ranking-place {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  letter-spacing: 0.02em;\n}\n\n.ios-ranking-week {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.ios-ranking-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  font-variant-numeric: tabular-nums;\n}\n\n.ios-ranking-chip--up {\n  color: #0f7a32;\n  background: rgba(50, 215, 75, 0.18);\n}\n\n.ios-ranking-chip--down {\n  color: #c42822;\n  background: rgba(255, 69, 58, 0.16);\n}\n\n.dark-mode .ios-ranking-chip--up {\n  color: #86f09a;\n}\n\n.dark-mode .ios-ranking-chip--down {\n  color: #ff8a82;\n}\n\n/* Objectives Card */\n.ios-objectives-card {\n  background: var(--bg-card);\n  border: var(--border-card);\n  border-radius: 16px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.club-health-card {\n  margin-top: 16px;\n  text-align: left;\n  color: var(--text-color);\n}\n\n.club-health-card .ios-objectives-header h3 {\n  color: var(--text-secondary);\n}\n\n.club-health-card .scforh-intro,\n.club-health-card .who-capsule,\n.club-health-card .scforh-dim-status {\n  margin: 0.65rem 0 0;\n}\n\n.club-health-card .who-capsule {\n  max-height: 42vh;\n  overflow-y: auto;\n}\n\n.who-capsule-profile {\n  width: min(100%, 360px);\n  margin: 12px auto 0;\n}\n\n.club-health-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.club-health-chip {\n  display: inline-flex;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(8, 119, 188, 0.1);\n  color: var(--brand-primary, #0877BC);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.club-health-empty {\n  margin: 0;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.club-health-letters {\n  display: flex;\n  gap: 8px;\n}\n\n.club-health-letter {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 13px;\n  background: #eee;\n  color: #888;\n}\n\n.club-health-letter--partial {\n  background: #fff4d6;\n  color: #b58100;\n}\n\n.club-health-letter--complete {\n  background: #d9f5e3;\n  color: #1b7a43;\n}\n\n.club-health-cta {\n  border: none;\n  border-radius: 12px;\n  padding: 12px 14px;\n  font-weight: 700;\n  cursor: pointer;\n  background: var(--brand-primary, #0877BC);\n  color: #fff;\n}\n\n.ios-objectives-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ios-objectives-header h3 {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  letter-spacing: 0.5px;\n}\n\n.ios-objective-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ios-objective-subtitle {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.ios-objective-subtitle.primary {\n  color: var(--brand-primary, #0877BC);\n}\n\n.ios-objective-subtitle.secondary {\n  color: var(--brand-secondary);\n}\n\n.ios-primary-box {\n  background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);\n  border-radius: 10px;\n  padding: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-color);\n  line-height: 1.4;\n}\n\n.ios-secondary-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  background-color: var(--profile-subtle-bg);\n  padding: 10px 12px;\n  border-radius: 8px;\n  margin-bottom: 6px;\n}\n\n.ios-secondary-item:last-child {\n  margin-bottom: 0;\n}\n\n.ios-bullet {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: var(--brand-secondary);\n  margin-top: 6px;\n  flex-shrink: 0;\n}\n\n.ios-secondary-text {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--profile-secondary-text);\n  line-height: 1.3;\n}\n\n/* Tab 2: Stats Elements */\n.ios-tab-content--stats {\n  gap: 12px;\n}\n\n.ios-stats-title {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  margin-bottom: -4px;\n  padding-left: 4px;\n}\n\n.ios-stat-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ios-stat-icon {\n  width: 26px;\n  height: 26px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ios-stat-icon--train {\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, transparent);\n}\n\n.ios-stat-icon--cardio {\n  color: var(--brand-danger, #ff453a);\n  background: color-mix(in srgb, var(--brand-danger, #ff453a) 14%, transparent);\n}\n\n.ios-stat-icon-well {\n  width: 56px;\n  height: 56px;\n  border-radius: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ios-stat-icon-well--streak {\n  color: #fff;\n  background: linear-gradient(\n    145deg,\n    var(--brand-warning, #ff9f0a) 0%,\n    color-mix(in srgb, var(--brand-danger, #ff453a) 55%, var(--brand-warning, #ff9f0a)) 100%\n  );\n  box-shadow: 0 8px 18px color-mix(in srgb, var(--brand-warning, #ff9f0a) 35%, transparent);\n}\n\n.ios-fltt-form {\n  margin: 0 0 14px;\n  padding: 16px;\n  border-radius: 18px;\n  background: var(--bg-card);\n  border: 1px solid color-mix(in srgb, #12362c 28%, var(--border-color, #d5ddd8));\n}\n\n.ios-fltt-form p {\n  margin: 6px 0 0;\n}\n\n.ios-fltt-form button {\n  margin-top: 12px;\n  border: 0;\n  border-radius: 999px;\n  background: #12362c;\n  color: #f3f6f4;\n  padding: 8px 14px;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.ios-activity-card {\n  background: var(--bg-card);\n  border: var(--border-card);\n  border-radius: 18px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  min-height: 112px;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.ios-activity-card--weekly {\n  gap: 16px;\n  padding: 18px 16px;\n  background:\n    radial-gradient(\n      90% 120% at 0% 50%,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent),\n      transparent 60%\n    ),\n    var(--bg-card);\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--border-color, transparent));\n}\n\n.ios-activity-card--streak {\n  background:\n    radial-gradient(\n      90% 120% at 0% 50%,\n      color-mix(in srgb, var(--brand-warning, #ff9f0a) 12%, transparent),\n      transparent 60%\n    ),\n    var(--bg-card);\n  border: 1px solid color-mix(in srgb, var(--brand-warning, #ff9f0a) 18%, var(--border-color, transparent));\n}\n\n/* Activity Ring SVG — viewBox keeps the stroke fully visible when scaled */\n.ios-ring-container {\n  position: relative;\n  width: 84px;\n  height: 84px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  overflow: visible;\n}\n\n.ios-ring-svg {\n  transform: rotate(-90deg);\n  width: 84px;\n  height: 84px;\n  overflow: visible;\n  display: block;\n}\n\n.ios-ring-bg {\n  fill: none;\n  stroke: var(--profile-ring-bg);\n  stroke-width: 7;\n}\n\n.ios-ring-fill {\n  fill: none;\n  stroke: var(--brand-primary, #0877BC);\n  stroke-width: 7;\n  stroke-linecap: round;\n  transition: stroke-dashoffset 0.8s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.ios-ring-text {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-color);\n  pointer-events: none;\n}\n\n.ios-activity-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  flex: 1;\n}\n\n.ios-activity-info h4 {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.ios-activity-value {\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--text-color);\n  margin: 0;\n}\n\n.ios-activity-sub {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--brand-primary, #0877BC);\n  margin: 0;\n}\n\n/* Streak Card */\n.ios-streak-info {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.ios-streak-info h4 {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.ios-streak-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-color);\n  margin: 0;\n}\n\n.ios-streak-sub {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--text-secondary);\n  line-height: 1.3;\n  margin: 0;\n}\n\n/* Cardio Card & Mini Metrics */\n.ios-cardio-card {\n  background:\n    radial-gradient(\n      80% 100% at 100% 0%,\n      color-mix(in srgb, var(--brand-secondary, #30d5c8) 10%, transparent),\n      transparent 55%\n    ),\n    var(--bg-card);\n  border: 1px solid color-mix(in srgb, var(--brand-secondary, #30d5c8) 16%, var(--border-color, transparent));\n  border-radius: 18px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ios-cardio-header {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.ios-mini-metrics-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.ios-mini-metric-item {\n  background-color: var(--profile-subtle-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 14px;\n  padding: 12px 6px 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  text-align: center;\n}\n\n.ios-mini-metric-item--hr {\n  border-color: color-mix(in srgb, var(--brand-danger, #ff453a) 22%, transparent);\n  background: color-mix(in srgb, var(--brand-danger, #ff453a) 7%, var(--bg-card, transparent));\n}\n\n.ios-mini-metric-item--hr .ios-metric-glyph {\n  color: var(--brand-danger, #ff453a);\n}\n\n.ios-mini-metric-item--max {\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 7%, var(--bg-card, transparent));\n}\n\n.ios-mini-metric-item--max .ios-metric-glyph {\n  color: var(--brand-primary, #0877bc);\n}\n\n.ios-mini-metric-item--kcal {\n  border-color: color-mix(in srgb, var(--brand-warning, #ff9f0a) 24%, transparent);\n  background: color-mix(in srgb, var(--brand-warning, #ff9f0a) 8%, var(--bg-card, transparent));\n}\n\n.ios-mini-metric-item--kcal .ios-metric-glyph {\n  color: var(--brand-warning, #ff9f0a);\n}\n\n.ios-metric-glyph {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 9px;\n  background: color-mix(in srgb, currentColor 12%, transparent);\n}\n\n.ios-metric-icon {\n  font-size: 18px;\n  margin-bottom: 4px;\n}\n\n.ios-metric-value {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-color);\n  line-height: 1.2;\n}\n\n.ios-metric-label {\n  font-size: 9px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-top: 1px;\n}\n\n/* Tab 3: My Gear Elements */\n.ios-gear-slot {\n  background: var(--profile-gear-bg);\n  border-radius: 16px;\n  border-width: 1.5px;\n  border-style: solid;\n  padding: 12px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  height: auto;\n  min-height: 58px;\n  box-sizing: border-box;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.ios-gear-slot.blade { border-color: rgba(255, 159, 10, 0.25); }\n.ios-gear-slot.forehand { border-color: rgba(255, 69, 58, 0.25); }\n.ios-gear-slot.backhand { border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25); }\n\n.ios-gear-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  flex: 1;\n}\n\n.ios-gear-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  width: 24px;\n  height: 24px;\n}\n\n.ios-gear-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n}\n\n.ios-gear-slot-title {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.ios-gear-slot.blade .ios-gear-slot-title { color: var(--brand-warning); }\n.ios-gear-slot.forehand .ios-gear-slot-title { color: var(--brand-danger); }\n.ios-gear-slot.backhand .ios-gear-slot-title { color: var(--brand-primary, #0877BC); }\n\n.ios-gear-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-color);\n  margin-top: 1px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ios-gear-edit-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--profile-gear-edit-color);\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: color 0.2s ease, background-color 0.2s ease, transform 0.15s ease;\n}\n\n.ios-gear-edit-btn:hover {\n  color: var(--text-color);\n  background-color: var(--profile-hover-bg);\n  transform: scale(1.08);\n}\n\n/* Gear Inline Form Edit State */\n.ios-gear-edit-form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  animation: formExpand 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n@keyframes formExpand {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ios-gear-edit-title {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.ios-gear-edit-inputs {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n.ios-gear-input {\n  flex: 1;\n  background-color: var(--profile-input-bg);\n  border: 1px solid var(--profile-input-border);\n  border-radius: 8px;\n  color: var(--text-color);\n  padding: 8px 12px;\n  font-size: 13px;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.ios-gear-input:focus {\n  border-color: var(--brand-primary, #0877BC);\n}\n\n.ios-gear-btn-save {\n  background-color: var(--brand-primary, #0877BC);\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.ios-gear-btn-save:hover {\n  opacity: 0.9;\n}\n\n.ios-gear-btn-cancel {\n  background-color: var(--profile-subtle-bg);\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.ios-gear-btn-cancel:hover {\n  background-color: var(--profile-hover-bg);\n  color: var(--text-color);\n}\n\n/* Weight Metric Card */\n.ios-weight-card {\n  background: var(--bg-card);\n  border: var(--border-card);\n  border-radius: 14px;\n  padding: 10px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 44px;\n  box-sizing: border-box;\n}\n\n.ios-weight-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.ios-weight-icon {\n  font-size: 18px;\n  opacity: 0.7;\n}\n\n.ios-weight-value {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-color);\n}\n\n/* Local Feedback Banner (for inline save feedback) */\n.ios-local-toast {\n  background-color: rgba(50, 215, 75, 0.15);\n  border: 1px solid rgba(50, 215, 75, 0.3);\n  color: var(--brand-success);\n  border-radius: 10px;\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  animation: slideDownToast 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n@keyframes slideDownToast {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Overrides for Userinfo */\n@media (max-width: 540px) {\n  .ios-profile-card {\n    border-radius: 20px;\n    padding: 16px;\n    gap: 16px;\n  }\n  .ios-avatar-wrapper, .ios-avatar, .ios-avatar-placeholder {\n    width: 80px;\n    height: 80px;\n  }\n  .ios-avatar-placeholder {\n    font-size: 32px;\n  }\n  .ios-profile-header h2 {\n    font-size: 18px;\n  }\n  .ios-profile-header .ios-email {\n    font-size: 12px;\n  }\n  .ios-segmented-control {\n    height: 40px;\n  }\n  .ios-segmented-control-btn {\n    font-size: 13px;\n  }\n  .ios-segmented-indicator {\n    border-radius: 10px;\n  }\n  .ios-attribute-grid {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n  .ios-mini-metrics-row {\n    gap: 6px;\n  }\n  .ios-mini-metric-item {\n    padding: 8px 4px;\n  }\n  .ios-metric-value {\n    font-size: 12px;\n  }\n  .ios-activity-card {\n    gap: 12px;\n  }\n  .ios-activity-card--weekly {\n    gap: 14px;\n    padding: 16px 14px;\n    min-height: 104px;\n    align-items: center;\n  }\n  .ios-ring-container {\n    width: 76px;\n    height: 76px;\n  }\n  .ios-ring-svg {\n    width: 76px;\n    height: 76px;\n  }\n  .ios-ring-text {\n    font-size: 13px;\n  }\n  .ios-activity-value {\n    font-size: 18px;\n    line-height: 1.2;\n    word-break: break-word;\n  }\n}\n\n/* Dedicated class for compact 2-column grid inside dialogs */\n.ios-attribute-grid.dialog-attribute-grid {\n  grid-template-columns: repeat(2, 1fr) !important;\n  gap: 10px !important;\n}\n\n/* Narrow mobile overrides to prevent tab label overlaps */\n@media (max-width: 400px) {\n  .ios-segmented-control-btn {\n    font-size: 11px !important;\n    letter-spacing: -0.2px !important;\n  }\n}\n\n@media (max-width: 340px) {\n  .ios-segmented-control-btn {\n    font-size: 10px !important;\n    letter-spacing: -0.4px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
